module.exports = __webpack_public_path__ + "static/Simulate-dea95102bc8f6d0fa825e6269bfbc833.svg";